import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import BACKOFFICE_BASE_API_V1 from "../utils/backofficeApi";
import "./Home.css";

function Home() {
  const { authPayload } = useAuth();
  const [articles, setArticles] = useState([]);
  const [venues, setVenues] = useState([]);
  const [products, setProducts] = useState([]);

  // Fetch articles
  useEffect(() => {
    fetch(`${BACKOFFICE_BASE_API_V1}/articles`)
      .then((response) => response.json())
      .then((data) => setArticles(data))
      .catch((error) => console.error("Error fetching articles:", error));
  }, []);

  const formatArticleDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleDateString("mk-MK", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getArticleExcerpt = (value, words = 22) => {
    const plain = String(value || "").replace(/<[^>]*>/g, " ").trim();
    if (!plain) return "Дознајте повеќе во целата статија.";
    const parts = plain.split(/\s+/).slice(0, words);
    return `${parts.join(" ")}${parts.length >= words ? "..." : ""}`;
  };

  useEffect(() => {
    fetch(
      `${BACKOFFICE_BASE_API_V1}/venues?category_id=fcbca939-d505-489f-9b5c-630ea1f3e430&active=true`
    )
      .then((response) => response.json())
      .then((data) => setVenues(data.slice(13, -1)))
      .catch((error) => console.error("Error fetching venues:", error));
  }, []);

  useEffect(() => {
    fetch(`${BACKOFFICE_BASE_API_V1}/products/all_products`)
      .then((response) => response.json())
      .then((data) => setProducts(data.products.slice(0, 10)))
      .catch((error) => console.error("Error fetching venues:", error));
  }, []);

  return (
    <div className="home-page">
      <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">Испланирајте ја вашата свадба од соништата</h1>
          <p>Креирајте магични моменти што ќе ги помните засекогаш.</p>
          <div className="hero-buttons">
            <Link to="/venues">
              <button className="btn-primary">Продавници</button>
            </Link>
            <Link to={authPayload?.id_token ? "/organizer" : "/login"}>
              <button className="btn-secondary">
                {authPayload?.id_token ? "Организатор" : "Најави се"}
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* Venues Section */}
      <section className="venues-home-list-section">
        <h2 className="section-title">Продавници</h2>
        {venues.length > 0 ? (
          <Swiper
            slidesPerView={1.2}
            spaceBetween={25}
            pagination={{ clickable: true }}
            modules={[Pagination]}
            className="venues-home-swiper"
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {venues.map((venue) => (
              <SwiperSlide key={venue.id}>
                <a href={`venue/${venue.id}`}>
                  <div className="venue-home-card">
                    <img
                      src={
                        venue.image_url ||
                        "https://placehold.co/600x400/weddings/white"
                      }
                      alt={venue.name}
                      className="venue-home-image"
                    />
                    <div className="venue-home-info">
                      <h3>{venue.name}</h3>
                      <div className="row">
                        <p>{venue.phone_number}</p>
                        <span>{venue.city}</span>
                      </div>
                    </div>
                  </div>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <Swiper
            slidesPerView={1.2}
            spaceBetween={25}
            pagination={{ clickable: true }}
            modules={[Pagination]}
            className="venues-home-swiper"
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {[...Array(3)].map((_, index) => (
              <SwiperSlide key={index}>
                <div key={index} className="venue-home-card">
                  <img
                    src="https://placehold.co/600x400/blank/blank"
                    alt="kazhavda sorabotnici"
                    className="venue-home-image"
                  />
                  <div className="venue-home-info">
                    <div className="no-venues-home-message">
                      Нема популарни места во моментов...
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        {/* View All Button */}
        <div className="view-all-container">
          <Link to="/venues" className="view-all-button">
            Погледни ги сите
          </Link>
        </div>
      </section>

      {/* Articles Section */}
      <section className="articles-section" id="articles-section">
        <div className="articles-content">
          <h2 className="section-title">Свадбени статии</h2>
          <div className="home-articles-grid">
            {articles.slice(0, 3).map((article) => (
              <article key={article.id} className="home-article-card">
                <img
                  src={
                    article.cover_picture_url ||
                    "https://placehold.co/700x420/f6f4ef/7f6f65?text=Kazhavda"
                  }
                  alt={article.title}
                  className="home-article-image"
                />
                <div className="home-article-content">
                  <span className="home-article-date">
                    {formatArticleDate(article.created_at)}
                  </span>
                  <h3>{article.title}</h3>
                  <p>{getArticleExcerpt(article.short_description)}</p>
                </div>
                {article.slug ? (
                  <Link
                    to={`/articles/${article.slug}`}
                    className="home-article-read-more"
                  >
                    Прочитај повеќе
                  </Link>
                ) : null}
              </article>
            ))}
          </div>
          <div className="articles-footer">
            <Link to="/articles" className="view-all">
              Погледни ги сите статии
            </Link>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="venues-home-list-section">
        <h2 className="section-title">Продукти</h2>
        {products.length > 0 ? (
          <Swiper
            slidesPerView={1.2}
            spaceBetween={25}
            pagination={{ clickable: true }}
            modules={[Pagination]}
            className="venues-home-swiper"
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {products.map((product) => (
              <SwiperSlide key={product.id}>
                <a href={`product/${product.id}?viewed_from=trending`}>
                  <div className="venue-home-card">
                    <img
                      src={
                        product.images[0] ||
                        "https://placehold.co/600x400/weddings/white"
                      }
                      alt={product.name}
                      className="venue-home-image"
                    />
                    <div className="venue-home-info">
                      <h3>{product.name}</h3>
                      <div className="row">
                        <p>{product.venue_name}</p>
                        <span>{product.price}</span>
                      </div>
                    </div>
                  </div>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <Swiper
            slidesPerView={1.2}
            spaceBetween={25}
            pagination={{ clickable: true }}
            modules={[Pagination]}
            className="venues-home-swiper"
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {[...Array(3)].map((_, index) => (
              <SwiperSlide key={index}>
                <div key={index} className="venue-home-card">
                  <img
                    src="https://placehold.co/600x400/blank/blank"
                    alt="kazhavda sorabotnici"
                    className="venue-home-image"
                  />
                  <div className="venue-home-info">
                    <div className="no-venues-home-message">
                      Нема популарни продукти во моментов...
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        {/* View All Button */}
        <div className="view-all-container">
          <Link to="/all-products" className="view-all-button">
            Погледни ги сите
          </Link>
        </div>
      </section>

      {/* Sponsored Section */}
      <section className="sponsored-section">
        <div className="sponsored-container">
          <img
            src="https://kazhavda-public.s3.eu-central-1.amazonaws.com/image1.jpeg"
            alt="Sponsored Left"
            className="sponsored-image sponsored-image-top"
          />
          <div className="sponsored-content">
            <img
              src="https://kazhavda-public.s3.eu-central-1.amazonaws.com/fora_mk_logo.png"
              alt="Sponsored Logo"
              className="sponsored-logo"
            />
            <h2 className="sponsored-title">Прекрасни идеи за свадба</h2>
            <p className="sponsored-description">
              Креативни дизајни за свадбата од вашите соништа!
            </p>
            <a
              href="https://instagram.com/fora.mk"
              className="sponsored-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Истражи повеќе - fora.mk
            </a>
          </div>
          <img
            src="https://kazhavda-public.s3.eu-central-1.amazonaws.com/image0.jpeg"
            alt="Sponsored Right"
            className="sponsored-image sponsored-image-bottom"
          />
        </div>
      </section>

      {/* Download App Section */}
      <section className="download-app-section" id="download-app-section">
        <div className="download-app-container">
          {/* Mobile App Image */}
          <div className="download-app-image-container">
            <img
              src="https://kazhavda-public.s3.eu-central-1.amazonaws.com/kazhavda_mobile_app.png"
              alt="Kazhav Da Mobile App"
              className="download-app-image"
            />
          </div>

          {/* Text Content */}
          <div className="download-app-content">
            <h2 className="section-title">
              Преземете ја нашата мобилна апликација
            </h2>
            <p>
              Организирајте ја вашата свадба лесно и брзо со нашата мобилна
              апликација.
            </p>
            <div className="download-app-links">
              <a
                href="https://play.google.com/store/apps/details?id=com.duotrio.kazhada"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Download on Google Play"
                  className="download-app-button"
                />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* What We Offer Section */}
      <section className="offer-section">
        <div className="offer-content">
          <h2 className="section-title">Нашата ексклузивна понуда</h2>
          <p>Сè што ви е потребно за вашата совршена свадба.</p>
          <div className="offer-grid">
            <div className="offer-item">
              <h3>Управување со гости и седење</h3>
              <p>
                Лесно распоредете и доделете места на гостите со паметен планер
                за седење..
              </p>
            </div>
            <div className="offer-item">
              <h3>Дигитален свадбен албум</h3>
              <p>
                Забележете и споделете незаборавни моменти во убаво организиран
                дигитален албум.
              </p>
            </div>
            <div className="offer-item">
              <h3>Координација на добавувачи и локации</h3>
              <p>
                Пронајдете и управувајте со добавувачи на свадбени торти,
                облека, хотели, ресторани и многу повеќе на едно место.
              </p>
            </div>
          </div>
        </div>
      </section>
      </div>
    </div>
  );
}

export default Home;
